export default __webpack_public_path__ + "static/media/D-Furnished.a48def26.png";